import { navigate } from "vike/client/router"

const RETRY_MS = 250
const ATTEMPTS = 8

/**
 * navigate() that survives vike's boot: for about a second after hydration the
 * router re-renders the current URL and silently drops navigations issued in
 * between. Retries until the location actually changed.
 */
export default async function clientRedirect(url, options) {
  const target = new URL(url, window.location.origin)
  const arrived = () => window.location.pathname === target.pathname && window.location.search === target.search
  for (let attempt = 0; attempt < ATTEMPTS; attempt++) {
    await navigate(url, options)
    if (arrived()) return true
    await new Promise((resolve) => setTimeout(resolve, RETRY_MS))
    if (arrived()) return true
  }
  return false
}
